import SendMessage from "./SendMessage.vue";
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      loading: true
    };
  },
  methods: {
    ...mapActions(["secondLogin"]),
    async login() {
      const {
        mobile: userKey,
        verificationCode,
        accountType,
        mobileAreaCode
      } = this.secondCheck;
      this.loading = false;
      const res = await this.secondLogin({
        userKey,
        verificationCode,
        accountType,
        mobileAreaCode
      });
      if (res && res.result === 0) {
        this.loading = true;
        this.secondCheck.show = false;
        // 二次验证通过后把登录结果交给父页面处理移动端跳转。
        this.$emit("getUnits", res);
      }
    }
  },
  components: {
    SendMessage
  },
  computed: {
    ...mapState({
      secondCheck: state => state.user.secondCheck
    })
    // form() {
    //   // let data
    //   let data = {
    //     mobile: "",
    //     email: "",
    //   };
    //   if (this.secondCheck.accountType === "MOBILE") {
    //     data.mobile = this.secondCheck.mobile;
    //   } else {
    //     data.email = this.secondCheck.mobile;
    //   }
    //   // const mobileList = this.secondCheck.mobile?.split("-");
    //   return {
    //     ...data,
    //     verificationCode: "",
    //     mobileAreaCode: this.secondCheck.mobileAreaCode,
    //   };
    // },
  }
};